import { Component, OnInit, ViewChild } from '@angular/core';
declare var jquery: any;
declare var $: any;
import 'datatables.net';
import { GridOptions } from "ag-grid/main";
import { Router } from "@angular/router";
import { Globals } from '../../globals';
import { ToastrService } from 'ngx-toastr';
import { ClientsService, RaterDto } from 'app/services/client/ClientsService';
import { RatersService } from 'app/services/rater/RatersService';
import { CoachService, ImportRatersDto, UpdateRaterDto } from 'app/services/coach/CoachService';
import { AdminService } from 'app/services/admin/AdminService';
import { RaterTypesForModalComponent } from '../c-rater-types/rater-types-for-modal/rater-types-for-modal.component';
import { RatersModalComponent } from '../raters-modal/raters-modal.component';
import { AssessmentsService } from '../../services/assessment/AssessmentsService';

@Component({
    selector: 'app-assigned',
    templateUrl: './assigned.component.html',
    styleUrls: ['./assigned.component.scss'] 
})
export class AssignedComponent implements OnInit  {

    @ViewChild('raterTypesForModal', {static: true}) public raterTypesForModal: RaterTypesForModalComponent;
    @ViewChild('ratersModal', {static: true}) private ratersModal: RatersModalComponent;
    data: string[] = [];
    dataHeaders: any[];
    dataHeaders360: any[];
    gridOptions: GridOptions;
    raterGridOptions: GridOptions;
    regularGridApi;
    gridApi360;
    raterGridApi;
    gridColumnApi;
    overlayNoRowsTemplate;
    raterOverlayNoRowaTemplate;
    //assessmentType: number = 1.1;

    height: number;
    count: number;

    loading: boolean = true;

    is360:boolean = false;
    ratersHeaders: any[];
    assignmentId: number;

    raters: any[] = [];

    /*new rater*/
    rater = {
        email: "",
        raterType: 0,
        firstName: "",
        lastName: ""
    }

    raterTypes: any[] = [];
    rowSelection = "multiple";
    ratersRowSelection = "multiple";
    //canDelete: boolean = false;
    //canCopy: boolean = false;

    //floatingFilter: boolean = true;
    inProgress: boolean = false;
    //canAddRaters: boolean = false;
    addingRater: boolean = false;

    //canUpdate: boolean = false;

    clientId: number;
    fileName: string = "";
    blobFile: any = null;

    //filters: string[] = ['ClientFullName', 'AssessmentName', 'Status', 'AssignedOn', 'ExpirationDate'];
    addRaterPageIdx: number = 0;
    languages: any[] = [];
    language: any;

    expiresOn: Date = new Date();
    sentDate: Date = new Date();
    date1: Date = new Date();

    settings = {
        bigBanner: false,
        timePicker: false,
        format: 'MM-dd-yyyy',
        defaultOpen: false
    };

    hours: string[] = [
        "00:00 AM",
        "01:00 AM",
        "02:00 AM",
        "03:00 AM",
        "04:00 AM",
        "05:00 AM",
        "06:00 AM",
        "07:00 AM",
        "08:00 AM",
        "09:00 AM",
        "10:00 AM",
        "11:00 AM",
        "12:00 PM",
        "01:00 PM",
        "02:00 PM",
        "03:00 PM",
        "04:00 PM",
        "05:00 PM",
        "06:00 PM",
        "07:00 PM",
        "08:00 PM",
        "09:00 PM",
        "10:00 PM",
        "11:00 PM"
    ];

    //canSend: boolean = false;
    //canSendReminder: boolean = false;
    scheduledDate: string = "";
    expiresIn: any;
    selectedHour: string = "";
    scheduleSelected: string = "";
    selectedGtmValue: number;

    /*import rater*/
    importRaterPageIdx: number = 0;
    importDate: Date = new Date();
    assignedRegularData: any[] = [];
    assigned360Data: any[] = [];

    tags = [];
    tags360 = [];
    addTags = [];
    assessmentEliTags = [];
    assessment360Tags = [];
    assessmentAddTags = [];
    placeholder: string = "Enter tag";
    sendingEmail: boolean = false;

    coachTags: any[] = [];
    coachTagsHeaders: any[];
    coachTagsGridApi;
    selectedCoachTags: any[] = [];
    currentAssessmentType: number;

    pointerEvents: boolean = true;
    canDeleteRaters: boolean = false;

    actionForRater: string = 'Add';
    raterForEdit: any;
    clientEmail: string;

    addingNewRater: boolean = false;
    currentAction: string = 'add';
    rowIndex: any;
    addedRaters: any[] = [];
    editedRaters: any[] = [];
    deletedRaters: any[] = [];
    categoryMin: number;

    //Definitive variables
    pristineRaters: any[] = [];
    arrActiveCategories: any[] = [];
    noRaters: boolean = false;
    lastRelationshipClicked: number;
    tempId = "tempId";
    counter = 0;
    raterTypesStandartData: string[] = [];
    raterTypesCustomData: string[] = [];
    raterTypesStandartDataHeaders: any[];
    raterTypesCustomDataHeaders: any[];
    raterTypesStandartGridApi;
    raterTypesCustomGridApi;
    isStandard: boolean = false;
    rtgridOptions: GridOptions;
    lastCategory: string = 'categories';
    ratertoDelete: any;
    bulkDeleteCategoryId: any;
    pristineCategories: any[] = [];
    executed: boolean = false;
    assessmentHour: string;
    selectedRowsCount = 0;
    selectedRow: any;

    constructor(
        public _AdminService: AdminService,
        public _AssessmentsService: AssessmentsService,
        public _CoachService: CoachService,
        private _RatersService: RatersService,
        private router: Router,
        public _Globals: Globals,
        private _ClientsService: ClientsService,
        public _toastr: ToastrService,
    ) {
        this.overlayNoRowsTemplate = '<span>No row to show</span>';
        this.raterOverlayNoRowaTemplate = '<span>There are no raters assigned to this assessment</span>';
        this.rowSelection = "multiple";
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.raterGridOptions = <GridOptions>{};
        this.raterGridOptions.rowHeight = 45;
        this.raterGridOptions.headerHeight = 40;

        this.rtgridOptions = <GridOptions>{};
        this.rtgridOptions.rowHeight = 45;
        this.rtgridOptions.headerHeight = 40;

        this._Globals.assignedCanConversionRate = false;

        this.dataHeaders = this.createHeaders();
        this.dataHeaders360 = this.createHeaders360();

        //get method
        //this.getCoachAssignedAssessments();
        if (this._Globals.assignedUserId == undefined) {
            this.getCoachAssignedAssessmentsByType(1);
            this.getCoachAssignedAssessmentsByType(2);
        } else {
            this.loading = false;
        }
        //this.getRaterTypes();
        this.getRaterTypesForCoach(false);
        //$('#hideFilter').addClass('notShow');

        this.getLanguages();

        //var w = window.innerWidth;
        //if (w < 480) {
        //    $('h1').css("padding-bottom", "30px");
        //}

        setTimeout(() => {
            $('.ng2-tag-input--focused').css('border-bottom', '2px solid skyblue');
        }, 2000);        
    }

    public getTodayDate2() {
        var today: any = new Date();
        var dd: any = today.getDate();

        var mm: any = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }
        today = yyyy + '-' + mm + '-' + dd;
/*        console.log(today);*/

        return today;
    }

    getRaterTypes() {
        this._ClientsService.getRaterTypes().subscribe((data: any) => {
            console.log('response_GetRaterTypes', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.raterTypes = _data;
                this.rater.raterType = _data[0].Id;
            }
        });
    }
    
    getLanguages() {
        this._AdminService.getLanguages().subscribe((data: any) => {
            console.log('languages', data.result);
            let result = data.result.Result;

            if (result <= -10) {
                //this.toastr.warning('Expired token please login again.', 'ELI');
                this.router.navigate(['/login']);
                this._Globals.deleteAllStorage();
                return;
            }

            let _data = JSON.parse(data.result.Data);
            this.languages = _data;
        });
    }

    //NOT IN USE    
    getCoachAssignedAssessments() {
        this._CoachService.getCoachAssignedAssessments().subscribe(data => {
            //console.log('getCoachAssignedAssessments', data);
            //this.data = data.result;
            //this.loading = false;
            //if (this.data.length === 0) {
            //    $('#assignedAssessments .ag-body-viewport.ag-layout-normal').css('background', 'white');
            //}


            console.log('response_getCoachAssignedAssessments', data);
            if (this._Globals.validationToken(data.result.Result)) {
                this.data = JSON.parse(data.result.Data);
                console.log('_data', this.data);
                this.loading = false;


                //if (this.data.length === 0) {
                //    $('#assignedAssessments .ag-body-viewport.ag-layout-normal').css('background', 'white');
                //}
            } 

        });
    }
    //NOT IN USE END

    getCoachAssignedAssessmentsByType(assessmentType: number) {
        //if (this.userId == undefined) this.userId = this._Globals.getUserId();
        this._CoachService.getCoachAssignedAssessmentsByType(assessmentType).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('getCoachAssignedAssessmentsByType_response', _data);
                if (assessmentType === 1) {
                    this._Globals.assignedRegularData = _data;
                } else {
                    this._Globals.assigned360Data = _data;
                }

                this.loading = false;
                this._Globals.assignedCanAddTags = false;
                this._Globals.assignedCanDelete = false;
                this._Globals.assignedCanCopy = false;
                this._Globals.assignedCanAddRaters = false;
                this._Globals.assignedCanUpdate = false;
                this._Globals.assignedCanSend = false;
                this._Globals.assignedCanSendReminder = false;
            }  
        });
    }

    getCoachAssignedAssessmentsByTypeByTag(assessmentType:number, tags:string[]) {
        this._CoachService.getCoachAssignedAssessmentsByTypeByTag(assessmentType, tags).subscribe((data: any) => {
            console.log('response_GetCoachAssignedAssessmentsByTypeByTag', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                if (_data.length > 0) {
                    if (assessmentType === 1) {
                        this._Globals.assignedRegularData = _data;
                    } else {
                        this._Globals.assigned360Data = _data;
                    }
                } else {
                    if (tags.length === 0) {
                        this.getCoachAssignedAssessmentsByType(assessmentType);
                    } else {
                        if (assessmentType === 1) {
                            this._Globals.assignedRegularData = [];
                        } else {
                            this._Globals.assigned360Data = [];
                        }
                    }
                }
                this._Globals.assignedCanAddTags = false;
                this._Globals.assignedCanDelete = false;
                this._Globals.assignedCanCopy = false;
                this._Globals.assignedCanAddRaters = false;
                this._Globals.assignedCanUpdate = false;
                this._Globals.assignedCanSend = false;
                this._Globals.assignedCanSendReminder = false;
            } 

        });
    }

    onItemAdded(assessmentType, e) {
        console.log("onItemAdded", e);

        if (assessmentType === 1) {
            this.assessmentEliTags.push(e.value);
            console.log(this.assessmentEliTags);
            this.getCoachAssignedAssessmentsByTypeByTag(1, this.assessmentEliTags);
        } else if (assessmentType === 2) {
            this.assessment360Tags.push(e.value);
            console.log(this.assessment360Tags);
            this.getCoachAssignedAssessmentsByTypeByTag(2, this.assessment360Tags);
        } else {
            this.assessmentAddTags.push(e.value);
            console.log(this.assessmentAddTags);
        }
    }

    onItemRemoved(assessmentType: number, e, removeFromDataBase: boolean = false) {
        console.log("onItemRemoved", e);

        if (assessmentType === 1) {
            const index = this.assessmentEliTags.indexOf(e.value);
            if (index !== -1) this.assessmentEliTags.splice(index, 1);
            console.log(this.assessmentEliTags);
            this.getCoachAssignedAssessmentsByTypeByTag(1, this.assessmentEliTags);
        } else if (assessmentType === 2) {
            const index = this.assessment360Tags.indexOf(e.value);
            if (index !== -1) this.assessment360Tags.splice(index, 1);
            console.log(this.assessment360Tags);
            this.getCoachAssignedAssessmentsByTypeByTag(2, this.assessment360Tags);
        } else {
            const index = this.assessmentAddTags.indexOf(e.value);
            if (index !== -1) this.assessmentAddTags.splice(index, 1);
            console.log(this.assessmentAddTags);
        }

        if(removeFromDataBase) {
            let tagText: string;
            if (e.value) {
                tagText = e.value;
            } else {
                tagText = e;
            }

            this._CoachService.postRemoveTag(String(this.selectedRow.Id), tagText)
                .subscribe((response: any) => {
                    if (this._Globals.validationToken(response.result.Result)) {
                        if (response.result.Result == 1) {
                            this._toastr.success('Tag removed successfully', 'ELI');
                        } else {
                            this._toastr.error('We are sorry, unexpected error removing the tag', 'ELI');
                        }
                    }
                },
                (err) => {
                    this._toastr.error('We are sorry, unexpected error removing the tag', 'ELI');
                });
        }
    }

    tabSelected(index) {
        console.log(index);    
        this._Globals.assignedAssessmentType = index;
        this.deselectAllCheckBox(this.regularGridApi);
        this.deselectAllCheckBox(this.gridApi360);

        if (index === 1.1) {
            this.sizeToFit(this.regularGridApi);
        } else {
            this.sizeToFit(this.gridApi360);
        }

        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 500);
    }

    showAssignedTabs() {
        $('.assignedTabs div').removeClass('active in');
        $('.assignedTabs li').removeClass('active');
        $('.assignedTabs li').eq(0).addClass('active');
        $('#assignedTab1').addClass('active');
        $('#assignedTab1').addClass('in');
    }

    filterAssigned(){
        this.is360 = !this.is360;
        //this.getCoachAssignedAssessmentsByType();
    }

    onResize(event: any) {
        console.log("Width: " , event.currentTarget.innerWidth);
        //console.log("Height: " , event.currentTarget.innerHeight);

        if (event.currentTarget.innerWidth < 855) {
            $('.card.shadow').css("margin-top", "46px");
        } else {
            $('.card.shadow').css("margin-top", "0px");
        }

        setTimeout(() => {
            if (this._Globals.assignedAssessmentType === 1.1) {
                if (this.regularGridApi != undefined) {
                    this.sizeToFit(this.regularGridApi);
                }
            } else {
                if (this.gridApi360 != undefined) {
                    this.sizeToFit(this.gridApi360);
                }
            }
        }, 500);
    }

    ngOnDestroy() {
        //$('h1').css("padding-bottom", "0px");
        console.log('ngOnDestroy');
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi: any) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onGridReady(assessmentType: number, params) {
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
        if (assessmentType === 1) {
            this.regularGridApi = params.api;
            this._Globals.assignedAssessmentGridApi = params.api;
        } else {
            this.gridApi360 = params.api;
        }
        //this._Globals.assignedAssessmentGridApi = this.gridApi;
        //this.sizeToFit(this.gridApi);
        //$('.ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%" });
    }

    onRaterGridReadyModal(params) {
        this.raterGridApi = params.api;
        this.sizeToFit(this.raterGridApi);
    }

    createHeaders() {
        let columnDefs = new Array();

        let coachHeader = {
            headerName: 'Client',
            field: 'ClientFullName',
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            minWidth: 150,
            width: 230,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(coachHeader);

        let nameHeader = {
            headerName: 'Assessment',
            field: 'AssessmentName',
            minWidth: 175,
            width: 250,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        let statusHeader = {
            headerName: 'Status',
            field: 'Status',
            minWidth: 110,
            width: 110,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(statusHeader);

        let completedHeader = {
            headerName: 'Send date',
            field: 'ScheduledDate',
            minWidth: 175,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(completedHeader);

        let expiresOnHeader = {
            headerName: 'Expires on',
            field: 'ExpirationDate',
            minWidth: 175,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(expiresOnHeader);

                //let actionsHeader = {
        //    headerName: 'Actions',
        //    field: '',
        //    width: 85,
        //    minWidth: 85,
        //    suppressSizeToFit: true,
        //    suppressSorting: true,
        //    suppressMenu: true,
        //    cellRenderer: (params) =>{
        //        let content = '';

        //        content += '<i id="deleteAction" class="material-icons">close</i>';
        //        if(this.is360){
        //            content += '<i id="assigned_raters" class="material-icons">supervisor_account</i>';
        //        }
        //        return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';
        //    }
        //};
        //columnDefs.push(actionsHeader);


        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'Niche',
        //    minWidth: 175,
        //    width: 175,
        //    suppressSizeToFit: true,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(nicheHeader);

        //let versionHeader = {
        //    headerName: 'Version',
        //    field: '',
        //    minWidth: 150,
        //    width: 150,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        let version = params.data['AssessmentMajorVersion'] + "." + params.data['AssessmentMinorVersion'];
        //        return version;
        //    }
        //};
        //columnDefs.push(versionHeader);  

        return columnDefs;
    }

    createHeaders360() {
        let columnDefs = new Array();

        let coachHeader = {
            headerName: 'Client',
            field: 'ClientFullName',
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            minWidth: 150,
            width: 230,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(coachHeader);

        let nameHeader = {
            headerName: 'Assessment',
            field: 'AssessmentName',
            minWidth: 175,
            width: 250,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        let completedHeader = {
            headerName: 'Send date',
            field: 'ScheduledDate',
            minWidth: 175,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(completedHeader);

        let expiresOnHeader = {
            headerName: 'Expires on',
            field: 'ExpirationDate',
            minWidth: 175,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(expiresOnHeader);

        let statusHeader = {
            headerName: 'Status',
            field: 'Status',
            minWidth: 110,
            width: 110,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(statusHeader);

        let generationHeader = {
            headerName: 'Ready for generation',
            field: 'ReadyForGeneration',
            minWidth: 110,
            width: 210,
            suppressSizeToFit: true,
            cellRenderer: function (params) {

                let content = "";
                if (params.data["ReadyForGeneration"]) {
                    content = "Yes";
                } else {
                    content = "No";
                }
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + content + '</div>';
            }
        };
        columnDefs.push(generationHeader);

        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            switch (e.event.target.id) {
                case "deleteAction":
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        this.delete();
                        break;
                    }

                case "assigned_raters":
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        //this.goToAssignedRaters();
                        //this.assignRaters(data['Id']);
                        break;
                    }
            }

            if (data.Status == "Completed") {
                console.log('Navigate');
                //this.router.navigate(['/app/co_a_report', data.Id, 'manage_assessments_assigned', 0]);
            }
        }
    }

    onRaterRowClicked(e) {
        console.log(e);
        if (!this.addingNewRater) {
            let rater = this.getSelectedRows(this.raterGridApi);
            this.raterForEdit = rater[0];
            this.rowIndex = e.rowIndex;
            console.log('Selected rater', this.raterForEdit);
        } else {
            this._toastr.warning("For edit please save or cancel the current rater entry.", "ELI");
            this.deselectAllCheckBox(this.raterGridApi);
            if (this.currentAction == 'edit') {
                this.raterGridApi.forEachNode((node) => {
                    if (node.data.Email === this.raterForEdit.Email) {
                        node.setSelected(true);
                    }
                });
            }
        }
    }
    
    goToAssignedRaters() {
        this.router.navigate(['/app/assigned_raters']);
    }

    delete() {
        if (this._Globals.assignedCanDelete) {
            let selected;
            if (this._Globals.assignedAssessmentType === 1.1) {
                selected = this.getSelectedRows(this.regularGridApi);
            } else {
                selected = this.getSelectedRows(this.gridApi360);
                
            }
            console.log("selected", selected);
            console.log('delete');
        }
    }

    showModal() {
        $("#assignedRatersModal").modal({ backdrop: "static" });
        $('#assignedRatersModal').modal('show');
    }
    
    closeModal() {
        $('#assignedRatersModal').modal('hide');
        this.addedRaters = [];
        this.editedRaters = [];
        this.deletedRaters = [];
        this.raters = [];
        this.arrActiveCategories = [];
        this.pristineCategories = [];
        this.executed = false;
        $('#mainAccordion .panel').css('display', 'none');
        //$('#relationships option')[0].selected = true;
        console.log('closeModal');
        $('.assignedAcc div').removeClass('in');
        $('#mainAccordion .panel').removeClass('accOpen');
        $('#mainAccordion .panel').addClass('accHide');
        $('.panel a').css('color', '#63ceeb');
        $('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
        this.hideEcConfirmCloseRatersModal();
        //this.deselectAllCheckBox(this.gridApi);
    }

    hideEcConfirmCloseRatersModal() {
        $('#assignedConfirmCloseRatersModal').modal('hide');
    }

    createRatersHeaders() {
        let columnDefs = new Array();
        console.log('header');

        let emailHeader = { 
            headerName: 'Email',
            field: 'Email',
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            minWidth: 200,
            width: 255,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(emailHeader);

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 300,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        let relationshipHeader = {
            headerName: 'Relationship',
            field: 'Relationship',
            minWidth: 150,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(relationshipHeader);

        //let addedByHeader = {
        //    headerName: 'AddedBy',
        //    field: 'AddedBy',
        //    minWidth: 200,
        //    width: 200,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(addedByHeader);

        let statusHeader = {
            headerName: 'Status',
            field: 'Status',
            minWidth: 150,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                switch (params.value) {
                    case 1:
                        return '<div style="overflow:hidden !important;text-overflow:ellipsis;">Pending</div>';
                    case 2:
                        return '<div style="overflow:hidden !important;text-overflow:ellipsis;">In progress</div>';
                    case 3:
                        return '<div style="overflow:hidden !important;text-overflow:ellipsis;">Completed</div>';
                }
            }
        };
        columnDefs.push(statusHeader);

        return columnDefs;
    }
    
    onSelectionChangedChoiceSet(event) {
        console.log("onSelectionChanged ", event);
        this.selectedRowsCount = event.api.getSelectedNodes().length;
        var rowCount = event.api.getSelectedNodes().length;
        if (rowCount === 1) {
            this.selectedRow = event.api.getSelectedNodes()[0].data;
        }
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount > 0) {
            let rows;
            if (this._Globals.assignedAssessmentType === 1.1) {
                rows = this.getSelectedRows(this.regularGridApi);
            } else {
                rows = this.getSelectedRows(this.gridApi360);
            }
            let assessmentInProgress = false;
            rows.forEach((client) => {
                console.log(client);
                if (client.Status != "Not started") {
                    assessmentInProgress = true;
                    return;
                }
            });
            if (!assessmentInProgress) {
                this._Globals.assignedCanDelete = true;
            } else {
                this._Globals.assignedCanDelete = false;
            }
            this._Globals.assignedCanAddTags = true;
        } else {
            this._Globals.assignedCanDelete = false;
            this._Globals.assignedCanAddTags = false;
        }

        if (rowCount == 1) {
            this._Globals.assignedCanCopy = true;
            this._Globals.assignedCanConversionRate = true;
        } else {
            this._Globals.assignedCanCopy = false;
            this._Globals.assignedCanConversionRate = false;
        }

        if (rowCount == 1) {
            let rows;
            if (this._Globals.assignedAssessmentType === 1.1) {
                rows = this.getSelectedRows(this.regularGridApi);
            } else {
                rows = this.getSelectedRows(this.gridApi360);
            }
            let is360 = true;
            rows.forEach((assessment) => {
                console.log(assessment);
                if (!assessment.Is360) {
                    is360 = false;
                    return;
                }
            });
            if (is360) {
                this._Globals.assignedCanAddRaters = true;
            } else {
                this._Globals.assignedCanAddRaters = false;
            }
        } else {
            this._Globals.assignedCanAddRaters = false;
        }

        if (rowCount > 0) {
            this._Globals.assignedCanUpdate = true;
            this._Globals.assignedCanSendReminder = true;
        } else {
            this._Globals.assignedCanUpdate = false;
            this._Globals.assignedCanSendReminder = false; 
        }

    }

    onRaterRowSelected(event) {
        console.log("onRaterRowSelected", event);
    }

    getSelectedRows(gridApi): any {
        console.log("SELECTED", gridApi.getSelectedRows());
        return gridApi.getSelectedRows();
    }

    getAssessmentLink(assessmentId: number) {
        this._AssessmentsService.getAssessmentLink(assessmentId).subscribe((data: any) => {
            console.log('getAssessmentLink_response', data);
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result == 1) {
                    console.log(data.result.Data);

                    let link = JSON.parse(data.result.Data);
                    $('#linkToCopy').text(link);

                    var $temp = $("<input>");
                    $("body").append($temp);
                    $temp.val($('#linkToCopy').text()).select();
                    document.execCommand("copy");
                    $temp.remove();

                    this._toastr.success('The assessment link has been copied to the clipboard', 'ELI');

                } else if (data.result.Result == 0) {
                    this._toastr.error("We are sorry. An error happened when trying to get the assessment link", "ELI");

                }
            }
        });
    }

    copy() {
        if (!this._Globals.assignedCanCopy) return; 

        let data;
        if (this._Globals.assignedAssessmentType === 1.1) {
            data = this.getSelectedRows(this.regularGridApi);
        } else {
            data = this.getSelectedRows(this.gridApi360);
        }

        this.getAssessmentLink(data[0].Id);
        
    }

    unassignAssessments() {
        let rows;
        if (this._Globals.assignedAssessmentType === 1.1) {
            rows = this.getSelectedRows(this.regularGridApi);
        } else {
            rows = this.getSelectedRows(this.gridApi360);
        }
        let assignmentIds = [];
        rows.forEach((client) => {
            console.log(client);
            assignmentIds.push(client.Id);
        });

        this._CoachService.postUnassignAssessments(assignmentIds).subscribe((data:any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result == 1) {

                    var rowCount;
                    let gridApi;
                    if (this._Globals.assignedAssessmentType === 1.1) {
                        rowCount = this.getSelectedRows(this.regularGridApi);
                        gridApi = this.regularGridApi;
                    } else {
                        rowCount = this.getSelectedRows(this.gridApi360);
                        gridApi = this.gridApi360;
                    }
                    
                    if (rowCount.length > 1) {
                        this._toastr.success("Assessments unassigned successfully.", "ELI");
                    } else {
                        this._toastr.success("Assessment unassigned successfully.", "ELI");
                    }
                    this._Globals.assignedCanCopy = false;
                    this._Globals.assignedCanDelete = false;
                    gridApi.forEachNode(function (node) {
                        node.setSelected(false);
                    });
                    this.getCoachAssignedAssessmentsByType(1);
                    this.getCoachAssignedAssessmentsByType(2);

                    //this.getCoachAssignedAssessments();
                    $('#confirmModal').modal('hide');
                    this.inProgress = false;

                } else {
                    this._toastr.error("An error happend, please try again.", "ELI");
                    this.inProgress = false;
                }
            } 

        });
    }

    openConfirmModal() {
        if (!this._Globals.assignedCanDelete) {
            this._toastr.warning("Please select the assignments you want to revert.", "ELI");
            return;
        };

        $("#confirmModal").modal({ backdrop: "static" });
        $('#confirmModal').modal('show');
    }

    confirm() {
        this.inProgress = true;
        this.unassignAssessments();
    }

    /*Import Modal*/

    showImportModal() {
        console.log('showImportModal');

        let pristineCategories = [];
        let activeCategories = $('.accOpen');
        console.log(activeCategories);

        for (var i = 0; i < $('.accOpen').length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            r = r.replace(",", "");
            pristineCategories.push(parseInt(r));
        }

        if (!this.arraysAreEqual(this.raters, this.pristineRaters) || !this.arraysAreEqual(this.pristineCategories, pristineCategories)) {
            this._toastr.warning("Import raters is not allowed until you save your current changes", "ELI");
            return;
        }
        $("#importRaterModal").modal({ backdrop: "static" });
        $('#importRaterModal').modal('show');
    }

    arraysAreEqual(ary1, ary2) {
        console.log(JSON.stringify(ary1));
        console.log(JSON.stringify(ary2));
        return (JSON.stringify(ary1) == JSON.stringify(ary2));
    }

    closeImportModal() {
        $('#importRaterModal').modal('hide');
        $('#iFile').val('');
        this.fileName = "";
        this.blobFile = null;
        this.importRaterPageIdx = 0;
    }
    
    getBlobFile(event: any) {
        console.log(event);
        let file = event.srcElement.value;
        console.log(file);
        let str = String.raw`\fakepath`;
        file = file.split(str);
        file = file[1].substring(1);
        this.fileName = file;

        this.blobFile = event.target.files[0];
    }

    okImportRaters() {
        $('body').css('cursor', 'wait');
        this.blobToBase64(this.blobFile);
    }

    blobToBase64(blobFile) {
        var reader = new FileReader();
        reader.readAsDataURL(blobFile);
        reader.onload = () => {
            console.log("Base64 file", reader.result);
            let base64file: any = reader.result.toString();
            base64file = base64file.split(',');
            this.importClients(base64file[1].toString());
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
            $('body').css('cursor', 'default');
        };
    }

    importClients(base64file: string) {
        let importRatersDto = new ImportRatersDto();

        importRatersDto.clientId = this.clientId;
        importRatersDto.assignmentId = this.assignmentId;
        importRatersDto.data = base64file;

        let scheduledDate = $('.wc-date-container span').text();
        //this.scheduledDate = this.scheduledDate.slice(0, 10);
        let tempDate = scheduledDate.split(" ");
        scheduledDate = tempDate[0];
        scheduledDate = scheduledDate.replace(/-/g, "/");
        console.log('scheduledFor', scheduledDate);

        let language = $('#importLanguages').val();
        console.log('language', language);
        importRatersDto.language = language;


        let expiresIn = $('#importExpiresIn').val();
        console.log('expiresIn', expiresIn);

        let selectedHour = $('#importHour').val();
        //this.selectedGtmText = $("#gtm option:selected").text();
        //this.selectedGtmValue = $('#gtm').val();
        let scheduleSelected = $("input[name='schedule']:checked").val();

        console.log(selectedHour);
        console.log(scheduleSelected);

        let selectedGtmValue;
        var d = new Date();
        var n = d.getTimezoneOffset();
        selectedGtmValue = (n / 60);
        importRatersDto.timeOffSet = selectedGtmValue;

        if (expiresIn > 30) expiresIn = 30;
        importRatersDto.expiresIn = parseInt(expiresIn);

        if (scheduleSelected === "0") {
            importRatersDto.sendEmailInvitationNow = true;
            var today = new Date();
            var dd = today.getDate();
            var mm: any = today.getMonth() + 1;
            if (mm < 10) { mm = '0' + mm; }
            var yyyy = today.getFullYear();

            let date = `${mm}/${dd}/${yyyy}`;

            var time = new Date();
            var currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
            currentHour = currentHour.split(' ');
            importRatersDto.scheduledFor = date + " " + currentHour[0] + ":00 " + currentHour[1];

        } else {
            importRatersDto.sendEmailInvitationNow = false;
            //var sDate = scheduledDate.split('/');
            //importRatersDto.scheduledFor = sDate[1] + '/' + sDate[2] + '/' + sDate[0] + " " + selectedHour;

            let scheduledFor = $('.wc-date-container span').text();
            let scheduledForArr = scheduledFor.split(' ');
            scheduledFor = scheduledForArr[3];
            scheduledFor = scheduledFor.substr(5);
            scheduledFor = scheduledFor.replace(/-/g, "/");
            console.log('scheduledFor', scheduledFor);

            importRatersDto.scheduledFor = scheduledFor + " " + selectedHour;
        }

        console.log('importRatersDto', importRatersDto);

        this._CoachService.postImportRaters(importRatersDto).subscribe((data: any) => {
            console.log('response_PostImportRaters', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_PostImportRaters data', _data);

                if (data.result.Result == 0) {
                    this._toastr.error("An error happened while trying to process the csv file.  Please verify that it is a valid file", "ELI");
                    $('body').css('cursor', 'default');
                } else if (data.result.Result == 1) {
                    this._toastr.success(`Total entries found: ${_data.TotalEntries} Imported: ${_data.SuccessEntries} Failed: ${_data.FailedEntries}`, "ELI");
                    this.getRaters(this.assignmentId, true);
                    this.closeImportModal();
                    $('body').css('cursor', 'default');
                }
            }
        });
    }

    importRaterNext() {
        if (this.blobFile == null) {
            this._toastr.warning("Please select an a .csv file.", "ELI");
            return;
        }

        this.importRaterPageIdx++;
        console.log(this.importRaterPageIdx);

        if (this.importRaterPageIdx == 1) {
            setTimeout(() => {
                var time = new Date();
                let currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
                currentHour = currentHour.split(' ');
                this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1], false);
            }, 100);
        }
    }

    importRaterPrev() {
        this.importRaterPageIdx--;
        console.log(this.importRaterPageIdx);
    }

    importHourChanged() {
        $('input:radio[name=schedule]').eq(0).prop('checked', false);
        $('input:radio[name=schedule]').eq(1).prop('checked', true);
    }

/*Raters*/

    emailExistForRater(newRaterEmail: string) {
        const rater = this.raters.filter((item) => {
            return item.Email == newRaterEmail
        });
        console.log(rater);
        return rater;
    }

    deleteSelectedRater() {
        var selectedRaters = this.raterGridApi.getSelectedRows();
        var res = this.raterGridApi.updateRowData({ remove: selectedRaters });
        var raterIndex = [];

        this.raters.forEach((item, index) => {
            for (var i = 0; i < selectedRaters.length; i++) {
                if (item.Email == selectedRaters[i].Email) {
                    if (item.RaterId != 0) {
                        let exist = this.deletedRaters.findIndex(x => x.Email === selectedRaters[i].Email);
                        if (exist == -1) {
                            item.RecordStatus = 2;
                            this.deletedRaters.push(item);
                        }
                    }
                    raterIndex.push(index);
                }
            }
        });

        raterIndex.sort(function (a, b) { return b - a; }).forEach(item => {
            this.raters.splice(item, 1);
            console.log('founded and deleted');
        });

        console.log('raters', this.raters);
        
        console.log('deleted', this.deletedRaters);
        let temRaters = this.raters;

        this.raters = [];

        setTimeout(() => {
            this.raters = temRaters;
            this.raterGridApi.redrawRows();
            this.sizeToFit(this.raterGridApi);
            this.hideDeleteRatersConfirmationModal();
            this.inProgress = false;
        }, 1);
    }

    finishSaveRaters() {
        this.scheduledDate = $('.wc-date-container span').text();
        //this.scheduledDate = this.scheduledDate.slice(0, 10);
        let tempDate = this.scheduledDate.split(" ");
        this.scheduledDate = tempDate[0];
        this.scheduledDate = this.scheduledDate.replace(/-/g, "/");
        console.log('scheduledFor', this.scheduledDate);

        this.language = $('#languages').val();
        console.log('language', this.language);

        this.expiresIn = $('#expiresIn').val();
        console.log('expiresIn', this.expiresIn);

        this.selectedHour = $('#hour').val();
        //this.selectedGtmText = $("#gtm option:selected").text();
        //this.selectedGtmValue = $('#gtm').val();
        this.scheduleSelected = $("input[name='schedule']:checked").val();

        console.log(this.selectedHour);
        console.log(this.scheduleSelected);

        let rater = new RaterDto();
        rater.ClientId = this.clientId;
        rater.AsignmentId = this.assignmentId;
        rater.Language = this.language;

        if (this.scheduleSelected === "0") {
            var d = new Date();
            var n = d.getTimezoneOffset();
            this.selectedGtmValue = (n / 60);
        }

        rater.TimeOffSet = this.selectedGtmValue;
        if (this.expiresIn > 30) this.expiresIn = 30;
        rater.ExpiresIn = parseInt(this.expiresIn);

        if (this.scheduleSelected === "0") {
            rater.SendEmailInvitationNow = true;
            var today = new Date();
            var dd = today.getDate();
            var mm: any = today.getMonth() + 1;
            if (mm < 10) { mm = '0' + mm; }
            var yyyy = today.getFullYear();

            let date = `${mm}/${dd}/${yyyy}`;

            var time = new Date();
            var currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
            currentHour = currentHour.split(' ');
            rater.ScheduledFor = date + " " + currentHour[0] + ":00 " + currentHour[1];
        } else {
            rater.SendEmailInvitationNow = false;
            //var sDate = this.scheduledDate.split('/');
            //rater.ScheduledFor = sDate[1] + '/' + sDate[2] + '/' + sDate[0] + " " + this.selectedHour;
            ////rater.ScheduledTime = this.selectedHour;

            let scheduledFor = $('.wc-date-container span').text();
            let scheduledForArr = scheduledFor.split(' ');
            scheduledFor = scheduledForArr[3];
            scheduledFor = scheduledFor.substr(5);
            scheduledFor = scheduledFor.replace(/-/g, "/");
            console.log('scheduledFor', scheduledFor);

            rater.ScheduledFor = scheduledFor + " " + this.selectedHour;
        }

        let raters = this.addedRaters.concat(this.editedRaters.concat(this.deletedRaters));
        raters.forEach((item) => {
            delete item.Id,
                delete item.Name,
                delete item.Relationship,
                delete item.Status,
                delete item.AddedBy
        });
        rater.Raters = raters;

        console.log("Rater", rater);

        //if (rater.Email == "" || rater.FirstName == "" || rater.LastName == "") {
        //    this._toastr.warning('Empty fields', 'ELI');
        //    return;
        //}

        //if (rater.Email === this.clientEmail) {
        //    this._toastr.warning("You cannot assign a client as a rater for her/him self.", "ELI");
        //    return;
        //}

        $('body').css('cursor', 'wait');
        this.addingRater = true;

        //if (!this.validateEmail(rater.Email)) {
        //    return;
        //}


        this._ClientsService.postSaveRaters(rater).subscribe((data: any) => {
            console.log('response_PostSaveRater', data);
            $('body').css('cursor', 'default');
            if (this._Globals.validationToken(data.result.Result)) {

                switch (data.result.Result) {
                    case -1:
                        this._toastr.warning('The specified user is already a rater for this assessment.', 'ELI');
                        break;
                    case 0:
                        this._toastr.error('We are sorry. An error happend while trying to save the client.', 'ELI');
                        break;
                    case 1:
                        this.addedRaters = [];
                        this.editedRaters = [];
                        this.deletedRaters = [];
                        this.getRaters(this.assignmentId, true);
                        this._toastr.success('Raters added successfully.', 'ELI');
                        this.closeNewRaterModal();
                        //this.closeModal();
                        break;
                }
                this.addingRater = false;
            }
        });
    }

    showNewRaterModal(action) {
        if (action == 'Add') {
            $("#assignedEmail").removeClass('disabled');
            this.rater.email = "";
            this.rater.firstName = "";
            this.rater.lastName = "";
            $('#assignedRaterTypesSelect option').eq(0).prop('selected', true);
        } else {
            $("#assignedEmail").addClass('disabled');
            this.rater.email = this.raterForEdit.Email;
            this.rater.firstName = this.raterForEdit.FirstName;
            this.rater.lastName = this.raterForEdit.LastName;
            $('#assignedRaterTypesSelect').val(this.raterForEdit.RelationshipId);
        }

        $("#assignedAddModal").modal({ backdrop: "static" });
        $('#assignedAddModal').modal('show');
        this.actionForRater = action;
    }

    closeNewRaterModal() {
        $('#assignedAddModal').modal('hide');
        $('#assignedAddModal').css('overflow', 'auto');
        console.log('hide');
        this.addRaterPageIdx = 0;
    }

    validateEmail(email: string, raterPosition: number): boolean {
        if (email !== "") {
            console.log("email", email);

            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            let validEmail = regex.test(email);
            console.log('Valid', validEmail)
            if (validEmail) {
                let exist = this.raters.findIndex(x => x.Email === email);
                if (exist != -1 && raterPosition != exist) {
                    this._toastr.warning('The specified Email address is already a rater for this assessment.', "ELI");
                    setTimeout(() => {
                        $('#relationships').trigger("click");
                    }, 100);
                    return false;
                } else {
                    return true;
                }
            } else {
                this._toastr.warning('Please enter a valid email address', "ELI");
                setTimeout(() => {
                    $('#relationships').trigger("click");
                }, 100);
                return false;
            }
        }
    }

    preventSpace(value: string, event: any, tagId: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $(`#${tagId}`).val('');
        }
    }

    addRaterNext() {
        this.addRaterPageIdx++;
        console.log(this.addRaterPageIdx);

        if (this.addRaterPageIdx == 1) {
            setTimeout(() => {
                var time = new Date();
                let currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
                currentHour = currentHour.split(' ');
                this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1], false);
            }, 100);
        }
    }

    addRaterPrev() {
        this.addRaterPageIdx--;
        console.log(this.addRaterPageIdx);
    }

    onDateSelect(date, dateTimeId) {
        date = new Date(date + 'T00:00:00');
        $('input:radio[name=schedule]').eq(0).prop('checked', false);
        $('input:radio[name=schedule]').eq(1).prop('checked', true);

        date.setHours(0, 0, 0, 0);
        console.log('onDateSelect', date);

        var today = new Date();
        today.setHours(0, 0, 0, 0);
        console.log("today", today);

        var currentHour: any = new Date().toLocaleString('en-US', { hour: 'numeric', hour12: true });
        currentHour = currentHour.split(' ');

        if (date < today) {
            this._toastr.warning("Please enter a date and time greater than the current date and time.", "ELI");
            if (dateTimeId == 1) this.sentDate = this.getTodayDate2();
            if (dateTimeId == 2) this.expiresOn = this.getTodayDate2();
            this.importDate = new Date();

            //currentHour[0] = parseInt(currentHour[0]);
            //if (currentHour[0] == 12) {
            //    currentHour[0] = 0;
            //}
            //currentHour[0] = (currentHour[0] + 1) + "";

            //if (currentHour[0].length == 1) {
            //    currentHour[0] = "0" + currentHour[0];
            //}

            //if (currentHour[0] == 12) {
            //    currentHour[1] = "PM";
            //}
            //currentHour = currentHour[0] + ":00 " + currentHour[1];
            //console.log('current Hour', currentHour);
            //$('#hour').val(currentHour);
            //$('#importHour').val(currentHour);

            this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1], false);
        } else if (date > today) {
            this.setAllHoursAndSelectAssessmentHour();
        } else {
            this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1], false);
        }
    }

    deselectAllCheckBox(gridApi) {
        this._Globals.assignedCanSend = false;
        gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    onSelectionChangedForRaters(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount >= 1) {
            this._Globals.assignedCanSend = true;

            let raters = this.getSelectedRows(this.raterGridApi);
            this.canDeleteRaters = true;
            raters.forEach((rater) => {
                console.log(rater);
                if (rater.Status != 1) this.canDeleteRaters = false;
            });
        } else {
            this._Globals.assignedCanSend = false;
            this.canDeleteRaters = false;
        }
    }

    deleteRaters() {
        let raters = this.getSelectedRows(this.raterGridApi);
        let ratersIds = [];

        raters.forEach((rater) => {
            console.log("rater", rater);
            ratersIds.push(rater.RaterId);
        });

        this._CoachService.postDeleteRaters(this.assignmentId, ratersIds).subscribe((data: any) => {

            this.inProgress = false;
            console.log('postDeleteRaters_response', data);

            if (this._Globals.validationToken(data.result.Result)) {
                this.getRaters(this.assignmentId, true);
                this.hideDeleteRatersConfirmationModal();

                if (data.result.Result == 1) {
                    this._toastr.success("Rater(s) deleted successfully.", "ELI");
                    this.deselectAllCheckBox(this.raterGridApi);
                } else if (data.result.Result == 0) {
                    this._toastr.error("We are sorry.  Some of the selected raters cannot be removed because they have either already initiated the assessment or completed it.", "ELI");
                }
            }
        });
    }

    formatAMPM(date) {
        console.log(date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    setSelectedHour(hour) {

        let currentHour: any = hour;
        currentHour = currentHour.split(' ');
        console.log(currentHour);

        currentHour[0] = parseInt(currentHour[0]);
        if (currentHour[0] == 12) {
            currentHour[0] = 0;
        }
        currentHour[0] = (currentHour[0] + 1) + "";

        if (currentHour[0].length == 1) {
            currentHour[0] = "0" + currentHour[0];
        }

        if (currentHour[0] == 12) {
            currentHour[1] = "PM";
        } 

        //currentHour = currentHour[0] + ":00 " + currentHour[1].toUpperCase();
        //console.log('Hour for current Assignment', currentHour);
        this.addNewHour(currentHour[0], currentHour[1], false);
        //$('#assessmemntsAssignedUpdateHour').val(currentHour);
    }

    private getDate(date) {
        var dd: any = date.getDate();

        var mm: any = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }
        date = yyyy + '-' + mm + '-' + dd;
        console.log(date);

        return date;
    }

    /*extended Modal*/

    public openExtendModal(): void {

        if (this._Globals.assignedCanUpdate) {
            let selected;
            if (this._Globals.assignedAssessmentType === 1.1) {
                selected = this.getSelectedRows(this.regularGridApi);
            } else {
                selected = this.getSelectedRows(this.gridApi360);
            }
            console.log(selected);
            selected.forEach(item => {
                this.sentDate = this.getDate(new Date(item.ScheduledDate));
                this.expiresOn = this.getDate(new Date(item.ExpirationDate));

                let date = new Date(item.ScheduledDate);
                let today = new Date();

                let currentHour: any = new Date().toLocaleString('en-US', { hour: 'numeric', hour12: true });
                currentHour = currentHour.split(' ');

                this.assessmentHour = this.formatAMPM(new Date(item.ScheduledDate))
                console.log('assessment hour', this.assessmentHour.toUpperCase());
                
                if (date < today) {
                    this.setAllHoursAndSelectAssessmentHour();
                } else if (date > today) {
                    this.setAllHoursAndSelectAssessmentHour();
                } else {
                    this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1], false);
                }

                console.log('InvitationSent', item.InvitationSent);
                if (item.InvitationSent) {
                    this.pointerEvents = false;
                    $('.schedule .wc-date-container').css('opacity', 0.3);
                    $('#assessmemntsAssignedUpdateHour').css('opacity', 0.3);
                    return;
                }
            });

            $("#extendModal").modal({ backdrop: "static" });
            $('#extendModal').modal('show');
        }
    }

    public closeExtendModal(): void {
        $('#extendedExpiresIn').val("")
        $('.schedule .wc-date-container').css('opacity', 1);
        $('#assessmemntsAssignedUpdateHour').css('opacity', 1);
        $('#extendModal').modal('hide');
        this.deselectAllCheckBox(this.regularGridApi);
        this.deselectAllCheckBox(this.gridApi360);
        this.expiresOn = this.getTodayDate2();
        this.sentDate = this.getTodayDate2();
        this.pointerEvents = true;
    }

    public extendExpirationDate(): void {

        let selected;
        if (this._Globals.assignedAssessmentType === 1.1) {
            selected = this.getSelectedRows(this.regularGridApi);
        } else {
            selected = this.getSelectedRows(this.gridApi360);
        }
        let assignmentIds = [];

        selected.forEach(item => {
            assignmentIds.push(item.Id);
        });

        let expiresOn = this.getInputDate('expiresDatePicker');
        if (expiresOn == "") return;
        let sentDate;
        if (this.pointerEvents) {
            sentDate = this.getInputDate('sentDateInput');
            if (sentDate == "") return;
        } else {
            sentDate = "";
        }

        let scheduledTime = $('#assessmemntsAssignedUpdateHour').val();

        var d = new Date();
        var n = d.getTimezoneOffset();
        let timeOffset = (n / 60);


        //let expirationExtend = parseInt($('#extendedExpiresIn').val());

        //if (expirationExtend <= 0 || isNaN(expirationExtend)) {
        //    this._toastr.warning("Plase enter a valid number.","ELI");
        //    return;
        //}

        this._CoachService.postUpdateAssignment(assignmentIds, expiresOn, sentDate, scheduledTime, timeOffset).subscribe((data: any) => {
            console.log('response_GetRaters', data);
            if (this._Globals.validationToken(data.result.Result)) {

                if (data.result.Result === 1) {
                    this._toastr.success("Expiration date extended successfully.", "ELI");
                    this.getCoachAssignedAssessmentsByType(1);
                    this.getCoachAssignedAssessmentsByType(2);
                    this.closeExtendModal();
                }
                else
                {
                    this._toastr.error("An error happened. Please try again", "ELI");
                }
            } 
        });
    }

    getDateTimePicker(pikerClass: string): string {
        let scheduledDate = $(`.${pikerClass} .wc-date-container span`).text();
        scheduledDate = scheduledDate.split(" ")[0].replace(/-/g, "/");
        console.log('scheduledFor', scheduledDate);

        if (new Date(scheduledDate) < new Date()) {
            this._toastr.warning("Please enter a date greater than the current date and time.", "ELI");
            return "";
        }

        return scheduledDate;
    }

    getInputDate(pikerClass: string): string {
        let scheduledDate = $(`#${pikerClass}`).val();
        scheduledDate = scheduledDate.split(" ")[0].replace(/-/g, "/");
        console.log('scheduledFor', scheduledDate);

        if (new Date(scheduledDate) < new Date()) {
            this._toastr.warning("Please enter a date greater than the current date and time.", "ELI");
            return "";
        }

        return scheduledDate;
    }

    setAllHoursAndSelectAssessmentHour() {
        this.addNewHour(0, "AM", true);
    }

    addNewHour(minHour: number, type: string, useAssessmentHour:boolean) {

        if (minHour == 13) {
            minHour = 1;
        }

        let amHours = [];
        let pmHours = [];

        if (type === "AM") {
            for (var i = minHour; i <= 11; i++) {
                if (i >= 10) {
                    amHours.push(i + ":00 AM");
                } else {
                    amHours.push("0" + i + ":00 AM");
                }
            }
            //adding the rest pm hours
            amHours.push("12:00 PM");
            minHour = 1;
            for (var j = minHour; j < 12; j++) {
                if (j >= 10) {
                    pmHours.push(j + ":00 PM");
                } else {
                    pmHours.push("0" + j + ":00 PM");
                }
            }
        } else {
            if (minHour == 12) {
                amHours.push("12:00 PM");
                minHour = 1;
            }
            for (var i = minHour; i < 12; i++) {
                if (i >= 10) {
                    pmHours.push(i + ":00 PM");
                } else {
                    pmHours.push("0" + i + ":00 PM");
                }
            }
        }
        console.log("this.hours", this.hours);
        this.hours = amHours.concat(pmHours);

        if (useAssessmentHour) {
            let currentHour:any = this.assessmentHour.split(' ');
            console.log(currentHour);
            currentHour[0] = currentHour[0].split(':')[0];
            console.log('length', currentHour[0].length);
            let hour = currentHour[0];
            if (hour.length == 1) {
                hour = "0" + currentHour[0];
            }
            setTimeout(() => {
                $('#assessmemntsAssignedUpdateHour').val(hour + ":00 " + currentHour[1].toUpperCase());
            }, 100);
        } else {
            $('#assessmemntsAssignedUpdateHour').val(this.hours[0]);
        }

    }

    monthToNumber(month): number {
        let index;

        var monthNames = [
            "Jan", "Feb", "Mar",
            "Apr", "May", "Jun", "Jul",
            "Aug", "Sep", "Oct",
            "Nov", "Dec"
        ];

        for (var i = 0; i < monthNames.length; i++) {
            if (month == monthNames[i]) {
                if (i.toString().length === 1) {
                    index = "0" + i;
                }
                return index;
            }
        }
        return index;
    }


    /*SEND REMINDER*/

    sendReminder() {
        if (this._Globals.assignedCanSendReminder) {
            let rows;
            if (this._Globals.assignedAssessmentType === 1.1) {
                rows = this.getSelectedRows(this.regularGridApi);
            } else {
                rows = this.getSelectedRows(this.gridApi360);
            }
            let assignmentIds = [];
            rows.forEach((client) => {
                console.log(client);
                assignmentIds.push(client.Id);
            });
            console.log("assignmentIds", assignmentIds);
            this.sendAssessmentReminder(assignmentIds);
        }
    }

    sendAssessmentReminder(assignmentIds: number[]) {
        if (!this.sendingEmail) {
            this.sendingEmail = true
            $('body, #sendReminder').css('cursor', 'wait');
            this._CoachService.postSendAssessmentReminder(assignmentIds).subscribe((data: any) => {
                console.log('response_PostSendAssessmentReminder', data);
                if (this._Globals.validationToken(data.result.Result)) {
                    if (data.result.Result == 1) {
                        this._toastr.success("Invitation email sent successfully", "ELI");
                    } else {
                        this._toastr.error("We are sorry. An error occurred while trying to send the invitation email.","ELI");
                    }
                }
                $('body, #sendReminder').css('cursor', 'default');
                this.sendingEmail = false;
            });
        }
    }

    focusTagsInput(id) {
        $('#' + id).focus();
    }

    onFocusInput() {
        console.log('onFocusInput');
        setTimeout(() => {
            $('.ng2-tag-input--focused').css('border-bottom', '2px solid skyblue');
        }, 100);
    }

    /*Get Coach Tags*/
    openTagsModal(type: number) {
        this.currentAssessmentType = type;
        $("#assignedTagsModal").modal({ backdrop: "static" });
        $('#assignedTagsModal').modal('show');
        this.coachTagsHeaders = this.createCoachTagsHeaders();
        this.getCoachTags();
        this.sizeToFit(this.coachTagsGridApi);
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    openAddTagsAssessmentsModal() {
        console.log('openAddTagsAssessmentsModal');
        if (this.selectedRowsCount > 1) {
            $("#assignedAddTagsModal").modal({ backdrop: "static" });
            $('#assignedAddTagsModal').modal('show');
            return;
        }
        
        if (this._Globals.assignedCanAddTags) {
            $("#assignedAddTagsModal").modal({ backdrop: "static" });
            $('#assignedAddTagsModal').modal('show');

            this._CoachService.getTagsByAssignmentId(this.selectedRow.Id)
                .subscribe((response: any) => {
                    if (this._Globals.validationToken(response.result.Result)) {
                        if (response.result.Result == 1) {
                            this.addTags = JSON.parse(response.result.Data).map((t: any) => t.Text);
                        } else {
                            this._toastr.error("We are sorry. An error occurred while trying to get assignment tags.","ELI");
                        }
                    }
                });
        }
    }

    closeAddTagsModal() {
        $('#assignedAddTagsModal').modal('hide');
        this.assessmentAddTags = [];
        this.addTags = [];
    }

    addAssessmentsTags() {
        console.log('assessmentAddTags', this.assessmentAddTags);
        console.log('addTags', this.addTags);

        let selected;
        if (this._Globals.assignedAssessmentType === 1.1) {
            selected = this.getSelectedRows(this.regularGridApi);
        } else {
            selected = this.getSelectedRows(this.gridApi360);
        }

        console.log(selected);
        let assignmentIds = [];

        selected.forEach((item) => {
            assignmentIds.push(item.Id)
        });

        console.log('assignmentIds', assignmentIds);

        this._CoachService.postAddAssessmentsTags(assignmentIds, this.assessmentAddTags).subscribe((data: any) => {
            console.log("postAddAssessmentsTags_RESPONSE", data);
            if (this._Globals.validationToken(data.result.Result)) {
                console.log(data);
                this.closeAddTagsModal();

                switch (data.result.Result) {
                    case 0:
                        this._toastr.error('We are sorry. An error happened when trying to add the tags to the selected assignments', 'ELI');
                        break;

                    case 1:
                        this._toastr.success('Tags were successfully added to the selected assignments');
                        if (this._Globals.assignedAssessmentType === 1.1) {
                            this.getCoachAssignedAssessmentsByType(1);
                        } else {
                            this.getCoachAssignedAssessmentsByType(2);
                        }
                        break;
                }
            }
        });
    }

    onCoachTagsGridReady(params) {
        this.coachTagsGridApi = params.api;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createCoachTagsHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Tag',
            field: 'Text',
            minWidth: 200,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);


        return columnDefs;
    }

    onCoachTagsRowClicked(e) {
        console.log(e);
    }

    onCoachTagsSelectionChanged(event) {
        console.log("onCoachTagsSelectionChanged ", event);

        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        this.selectedCoachTags = this.getSelectedRows(this.coachTagsGridApi);
        console.log("selectedCoachTags", this.selectedCoachTags);
    }

    getCoachTags() {
        this._CoachService.getCoachTags().subscribe((data: any) => {
            console.log('getCoachTags data', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetCoachTags', _data);
                this.coachTags = _data;
            }
        });
    }

    removeTag(index, text) {
        console.log(index);

        this.selectedCoachTags.splice(index, 1);
        console.log(this.selectedCoachTags);

        this.coachTagsGridApi.forEachNode((node) => {
            console.log(node);
            if (text === node.data.Text) {
                node.setSelected(false);
            }
        });
    }

    addNewCoachTags() { 

        this.selectedCoachTags.forEach((item) => {

            if (this.currentAssessmentType === 1) {
                if (!this.tags.find(x => x.value === item.Text)) {
                    let tag = { display: item.Text, value: item.Text };
                    this.tags.push(tag);
                    this.onItemAdded(1, tag);
                }
            } else if (this.currentAssessmentType === 2){
                if (!this.tags360.find(x => x.value === item.Text)) {
                    let tag = { display: item.Text, value: item.Text };
                    this.tags360.push(tag);
                    this.onItemAdded(2, tag);
                }
            } else {
                if (!this.addTags.find(x => x.value === item.Text)) {
                    let tag = { display: item.Text, value: item.Text };
                    this.addTags.push(tag);
                    this.onItemAdded(3, tag); //add tags modal
                }
            }

        });
        this.closeTagsModal();
    }

    isInArray(value, array) {
        return array.indexOf(value) > -1;
    }

    closeTagsModal() {
        $('#assignedTagsModal').modal('hide');
        this.selectedCoachTags = [];
    }

    /*raterTypesForModal*/
    openRaterTypesForModal() {
        this.raterTypesForModal.show(this, 2);
    }

/*--------------Definitive methods---------------*/ 

    assignRaters() {
        console.log('assignRaters');
        let selected = this.getSelectedRows(this.gridApi360);
        this.getRaters(selected[0].Id, true);
        this.showModal();
    }

    getRaters(assignmentId: number, refreshData: boolean, oneOpen?: number) {
        console.log('getRaters');
        this.assignmentId = assignmentId;

        this._ClientsService.getRaters(this.assignmentId).subscribe((data: any) => {
            console.log('response_GetRaters', data);

            if (this._Globals.validationToken(data.result.Result)) {

                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.pristineRaters = JSON.parse(data.result.Data);

                if (this.addedRaters.length > 0 || this.editedRaters.length > 0 && refreshData) {
                    //updating the properties for edited entries
                    _data.forEach((item, index) => {
                        for (var i = 0; i < this.editedRaters.length; i++) {
                            if (item.Email == this.editedRaters[i].Email) {
                                _data[index] = this.editedRaters[i];
                            }
                        }
                    });
                    this.raters = _data.concat(this.addedRaters);
                    console.log('raters', this.raters);
                } else {
                    //from database
                    if (refreshData) {
                        this.raters = _data;

                        for (var i = 0; i < this.raters.length; i++) {
                            if (i == 0) {
                                $(".assignedAcc #acc" + this.raters[i].RelationshipId).insertAfter('#forFirstelement');
                            } else {
                                let beforeElement = this.raters[(i - 1)].RelationshipId;
                                $(".assignedAcc #acc" + this.raters[i].RelationshipId).insertBefore('.assignedAcc #acc' + beforeElement);
                            }

                            $('.assignedAcc #acc' + this.raters[i].RelationshipId).css('display', 'block');
                            $('.assignedAcc #acc' + this.raters[i].RelationshipId).removeClass('accHide');
                            $('.assignedAcc #acc' + this.raters[i].RelationshipId).addClass('accOpen');
                            //$('#relationships').val(r.RelationshipId);
                        }
                    } else {
                        //this.arrActiveCategories.forEach((r) => {
                        for (var i = 0; i < this.arrActiveCategories.length; i++) {
                            if (i == 0) {
                                $(".assignedAcc #acc" + this.arrActiveCategories[i]).insertAfter('#forFirstelement');
                            } else {
                                let beforeElement = this.arrActiveCategories[(i - 1)];
                                $(".assignedAcc #acc" + this.arrActiveCategories[i]).insertAfter('.assignedAcc #acc' + beforeElement);
                            }
                            $('.assignedAcc #acc' + this.arrActiveCategories[i]).css('display', 'block');
                            $('.assignedAcc #acc' + this.arrActiveCategories[i]).removeClass('accHide');
                            $('.assignedAcc #acc' + this.arrActiveCategories[i]).addClass('accOpen');
                            //$('#relationships').val(r); 
                        }
                    }

                    this.checkRatersAmount();

                    if (!this.executed) {
                        this.executed = true;
                        let pristineCategories = $('.accOpen');
                        console.log(pristineCategories);

                        for (var i = 0; i < $('.accOpen').length; i++) {
                            let r = pristineCategories[i].id.match(/\d/g).join(',');
                            r = r.replace(",", "");
                            this.pristineCategories.push(parseInt(r));
                        }
                    }

                    if (oneOpen > 0) {
                        //open the first catefory
                        let firstElement = $('.accOpen a');
                        firstElement[0].click();
                        firstElement[0].children[0].children[1].classList.value = 'fas fa-angle-up';
                    }
                    //this.drawData();
                }

                this.loading = false;
                //this.sizeToFit(this.raterGridApi);
            }
        });
    }

    checkRatersAmount() {
        console.log('checkRatersAmount');
        let accOpen = $('.accOpen').length;
        console.log(accOpen);

        if (accOpen == 0) {
            this.noRaters = true;
        } else {
            this.noRaters = false;
        }
    }

    drawData(relationshipId: number, relationshipMin: number, e?) {
        console.log(e);
        //reset all angle icons down
        if (this.lastRelationshipClicked != relationshipId) {
            $('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
        }

        if (e != undefined) {
            //h4 clicked
            if (e.target.nodeName == 'H4') {
                if (e.target.nextElementSibling.classList.value == 'fas fa-angle-up') {
                    e.target.nextElementSibling.classList.value = 'fas fa-angle-down';
                } else {
                    e.target.nextElementSibling.classList.value = 'fas fa-angle-up';
                }
            }

            //a clicked
            if (e.target.nodeName == 'DIV') {
                if (e.target.children[1].classList.value == 'fas fa-angle-up') {
                    e.target.children[1].classList.value = 'fas fa-angle-down';
                } else {
                    e.target.children[1].classList.value = 'fas fa-angle-up';
                }
            }

            //i clicked
            if (e.target.nodeName == 'I') {
                if (e.target.classList.value == 'fas fa-angle-up') {
                    e.target.classList.value = 'fas fa-angle-down';
                } else {
                    e.target.classList.value = 'fas fa-angle-up';
                }
            }
        }

        this.lastRelationshipClicked = relationshipId;

        let filteredRaters = this.raters.filter((r) => {
            if (r.RelationshipId === relationshipId) return r;
        });
        console.log('filteredRaters', filteredRaters);

        //display min message if category doesnt have enought raters
        this.displayMinMessage(relationshipId);

        $('.assignedCategoryEntries').html(``);

        let disabled = 'disabled';
        if (filteredRaters.length > 0) {
            filteredRaters.forEach((item) => {
                let raterId = item.RaterId;
                if (item.tempIdCounter) {
                    disabled = ''
                    raterId = item.tempIdCounter
                }

                let classes = 'd-none d-sm-inline-block btn btn-sm btn-primary sendEntry';
                if (item.tempIdCounter) {
                    classes = 'd-none d-sm-inline-block btn btn-sm btn-gray';
                }
                $('.assignedCategoryEntries').append(`
                    <div class="row" data-raterId="${raterId}" data-relationshipId="${relationshipId}" style="padding: 0px 2px;display: inline-flex;width: 100%;margin: 0px;position: relative;top: -13px;">
                        <div class="" style="padding: 0px;width:25%;min-width:150px;"><input style="width:100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="First Name" name=FirstName type="text" value="${item.FirstName}" /></div>
                        <div class="" style="padding: 0 0 0 10px;width:25%;min-width:150px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Last Name" name="LastName" type="text" value="${item.LastName}" /></div>
                        <div class="" style="padding: 0 10px 0 10px;width:30%;min-width:150px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Email" name="Email" ${disabled} type="text" value="${item.Email}" /></div>
                        <div class="dinamicResponsive" style="width:20%;">
                            <a _ngcontent-c2="" class="${classes}">
                                <span>Resend Invitation</span>
                                <i _ngcontent-c2="" class="fas fa-paper-plane text-white-50"><span _ngcontent-c2="" class="button-text"> Resend Invitation</span></i>
                            </a>
                            <a _ngcontent-c2="" class="d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry">
                                <span>Delete</span>
                                <i _ngcontent-c2="" class="fas fa-trash text-white-50"><span _ngcontent-c2="" class="button-text"> Delete</span></i>
                            </a>
                        </div>    
                    </div>
                `);
            });

            //adding the minimun rater entries
            for (var i = 0; i < relationshipMin - filteredRaters.length; i++) {
                this.addNewRaterEntry(relationshipId);
            }
        } else {
            for (var i = 0; i < relationshipMin; i++) {
                this.addNewRaterEntry(relationshipId);
            }
        }
    }

    displayMinMessage(relationshipId: number) {
        //display min message if category doesnt have enought raters
        let categoryRaters = this.raters.filter((r) => {
            if (relationshipId == r.RelationshipId) return r;
        });

        let rt = this.raterTypes.findIndex(x => x.Id === relationshipId);
        let min;
        if (rt != -1) {
            min = this.raterTypes[rt].Min;
        }

        if (categoryRaters.length < min) {
            $('.categoryMinMessage span').text('You need a minimum of ' + min + ' raters for this category.');
            $('.removeButtonText').text('Remove Category');
        } else {
            $('.categoryMinMessage span').text('');
            $('.removeButtonText').text('Remove All');
        }
    }

    addNewRaterEntry(relationshipId: number) {
        //get the relationship min
        let relationship = this.raterTypes.filter((rt) => {
            if (relationshipId == rt.Id) return rt;
        });

        let classes = "";
        let inputEntries = $('.assignedAcc #acc' + relationshipId + ' .assignedCategoryEntries .row');
        if (relationship.length != 0) {
            classes = 'd-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry';

            $('.assignedCategoryEntries').append(`
                    <div class="row" data-raterId="${this.tempId}${this.counter}" data-relationshipId="${relationshipId}" style="padding: 0px 2px;display: inline-flex;width: 100%;margin: 0px;position: relative;top: -13px;">
                        <div class="" style="padding: 0px;width:25%;min-width:150px;"><input style="width:100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="First Name" name=FirstName type="text" value="" /></div>
                        <div class="" style="padding: 0 0 0 10px;width:25%;min-width:150px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Last Name" name="LastName" type="text" value="" /></div>
                        <div class="" style="padding: 0 10px 0 10px;width:30%;min-width:150px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Email" name="Email" type="text" value="" /></div>
                        <div class="dinamicResponsive" style="width:20%;">
                            <a _ngcontent-c2="" class="d-none d-sm-inline-block btn btn-sm btn-gray">
                                <span _ngcontent-c2="">Resend Invitation</span>
                                <i _ngcontent-c2="" class="fas fa-paper-plane text-white-50"><span _ngcontent-c2="" class="button-text"> Resend Invitation</span></i>
                            </a>
                            <a _ngcontent-c2="" class="${classes}">
                                <span _ngcontent-c2="">Delete</span>
                                <i _ngcontent-c2="" class="fas fa-trash text-white-50"><span _ngcontent-c2="" class="button-text"> Delete</span></i>
                            </a>
                        </div>                        
                    </div>
                `);
            this.counter++;
        }
    }

    openAddRelationshipsModal() {
        console.log('openAddRelationshipsModal');

        this.raterTypesStandartDataHeaders = this.createRaterTypesHeaders();
        this.raterTypesCustomDataHeaders = this.createRaterTypesHeaders();
        this.getGlobalRaterTypes();
        this.getRaterTypesByCoach();
        this.showRelationshipsModal();
    }

    createRaterTypesHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        return columnDefs;
    }

    getGlobalRaterTypes() {
        this._AdminService.getGlobalRaterTypes().subscribe((data: any) => {
            console.log('response_GetGlobalRaterTypes', data);
            this.loading = false;

            if (this._Globals.validationToken(data.result.Result)) {
                this.raterTypesStandartData = JSON.parse(data.result.Data);
                console.log('data', this.raterTypesStandartData);

                setTimeout(() => {
                    this.sizeToFit(this.raterTypesStandartGridApi);
                }, 100);
            }
        });
    }

    getRaterTypesByCoach() {
        this._CoachService.getRaterTypesByCoach().subscribe((data: any) => {
            console.log('response_GetRaterTypesByCoach', data);

            this.loading = false;
            if (this._Globals.validationToken(data.result.Result)) {
                this.raterTypesCustomData = JSON.parse(data.result.Data);
                console.log('data', this.raterTypesCustomData);

            }
        });
    }

    showRelationshipsModal() {
        $('#assignedAddRelationshipsModal').modal('show');
        $('.add-rater-types-modal li').removeClass('active').eq(0).addClass('active');
    }

    hideRelationshipsModal() {
        $('.add-rater-types-modal li:first-child a').trigger('click');
        $('#assignedAddRelationshipsModal').modal('hide');
    }

    onRaterTypesStandartGridReady(params) {
        this.raterTypesStandartGridApi = params.api;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onRaterTypesCustomGridReady(params) {
        this.raterTypesCustomGridApi = params.api;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onRaterTypesRowClicked(e) {
        console.log(e);
    }

    onRaterSelectionChanged(event) {
        console.log("onRaterSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");
    }

    loadData(type: number) {
        switch (type) {
            case 1:
                console.log('1');
                this.isStandard = false;
                //this.getRaterTypesByCoach();
                setTimeout(() => {
                    this.sizeToFit(this.raterTypesCustomGridApi);
                }, 100);
                break;

            case 2:
                console.log('2');
                this.isStandard = true;
                //this.getGlobalRaterTypes();
                setTimeout(() => {
                    this.sizeToFit(this.raterTypesStandartGridApi);
                }, 100);
                break;
        }
    }

    addRelationships() {
        console.log('addRelationships');
        let standartRows = this.getSelectedRows(this.raterTypesStandartGridApi);
        let globalRows = this.getSelectedRows(this.raterTypesCustomGridApi);
        console.log('rows', standartRows);
        console.log('rows', globalRows);

        let rows = standartRows.concat(globalRows);

        let arrActiveCategories = [];
        let activeCategories = $('.accOpen');
        console.log(activeCategories);
        for (var i = 0; i < activeCategories.length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            r = r.replace(",", "");
            arrActiveCategories.push(parseInt(r));
        }

        rows.forEach((r) => {
            let categoryIndex = arrActiveCategories.findIndex(x => x === r.Id);
            if (categoryIndex == -1) {
                this.createCategoryContent(r.Id, r.Min, rows[rows.length - 1].Id);
            }
        });
        this.hideRelationshipsModal();
    }

    createCategoryContent(id, min, lastId?: number) {
        let accOpen = $('.accOpen');
        let lastAcc;
        if (accOpen.length > 0) {
            lastAcc = accOpen[0].id;
            $(".assignedAcc #acc" + id).insertBefore('.assignedAcc #' + lastAcc);
        } else {
            $(".assignedAcc #acc" + id).insertAfter('#forFirstelement');
        }
        $('.assignedAcc #acc' + id).css('display', 'block');
        $('.assignedAcc #acc' + id).removeClass('accHide');
        $('.assignedAcc #acc' + id).addClass('accOpen');
        this.lastCategory = id;

        this.checkRatersAmount();
        if (id == lastId) {
            $('.assignedAcc #acc' + id + ' .accDiv a').trigger('click');
            this.drawData(id, min);


            setTimeout(() => {
                let accOpen = $('.accOpen');
                console.log(accOpen);
                $('.accOpen')[0].children[0].children[0].children[0].children[1].classList.value = "fas fa-angle-up";
            }, 200);
        }
    }

    ngAfterContentInit() {
        $(document).on('click', '#assignedRatersModal .deleteRaterEntry', (e) => {
            this.showDeleteRatersConfirmationModal(e);
            this.ratertoDelete = e;
        });

        $(document).on('focusout', '#assignedRatersModal .raterEntry', (e) => {
            this.editRaterEntry(e);
        });

        $(document).on('click', '#assignedRatersModal .sendEntry', (e) => {
            $('body').css('cursor', 'wait');
            this.sendEmail(e);
        });
        this.checkRatersAmount();
    }

    editRaterEntry(e: any) {
        console.log('focusout event', e);

        let raterId = e.target.parentElement.parentElement.dataset.raterid;
        console.log('raterId', raterId);

        let regex = /tempId/;
        let result = regex.test(raterId);
        let relationshipId = parseInt(e.target.parentElement.parentElement.dataset.relationshipid);

        if (!result) {
            let raterPosition = this.raters.findIndex(x => x.RaterId === parseInt(raterId));
            if (raterPosition != -1) {
                if (e.target.name == 'Email') {
                    if (!this.validateEmail(e.target.value, raterPosition)) {
                        e.target.value = "";
                        //return;
                    }
                }
                this.raters[raterPosition].RecordStatus = 1;
                this.raters[raterPosition][e.target.name] = e.target.value;
                if (e.target.value != "") {
                    e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                } else {
                    let canDisable = true;
                    for (var i = 0; i < 3; i++) {
                        if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                            canDisable = false;
                        }
                    }
                    if (canDisable) {
                        this.raters.splice(raterPosition, 1);
                        //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    }
                }
            } else {
                let newRater = {
                    Email: "",
                    RaterId: 0,
                    FirstName: "",
                    LastName: "",
                    RelationshipId: relationshipId,
                    RecordStatus: 0,
                    tempIdCounter: 'tempId' + this.counter
                };
                this.raters.push(newRater);
                this.raters[this.raters.length - 1][e.target.name] = e.target.value;
                e.target.parentElement.parentElement.dataset.raterid = 'tempId' + this.counter;
                if (e.target.value != "") {
                    e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                } else {
                    let canDisable = true;
                    for (var i = 0; i < 3; i++) {
                        if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                            canDisable = false;
                        }
                    }
                    if (canDisable) {
                        this.raters.splice(this.raters.length, 1);
                        //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    }
                }
                this.counter++;
            }
        }
        else {
            //finding the position of the added memory entry tempIdCounter
            let raterPosition = this.raters.findIndex(
                x => x.tempIdCounter == raterId
            );
            if (raterPosition != -1) {
                if (e.target.name == 'Email') {
                    if (!this.validateEmail(e.target.value, raterPosition)) {
                        e.target.value = "";
                        //return;
                    }
                }
                this.raters[raterPosition][e.target.name] = e.target.value;
                if (e.target.value != "") {
                    e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                } else {
                    let canDisable = true;
                    for (var i = 0; i < 3; i++) {
                        if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                            canDisable = false;
                        }
                    }
                    if (canDisable) {
                        this.raters.splice(raterPosition, 1);
                        //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    }
                }
                //EDITING A MEMORY ENTRY
            } else {
                //TOTALLY NEW ENTRY
                console.log('relationshipId', relationshipId);

                if (e.target.name == 'Email') {
                    if (!this.validateEmail(e.target.value, -1)) {
                        e.target.value = "";
                        //return;
                    }
                }

                let newRater = {
                    Email: "",
                    RaterId: 0,
                    FirstName: "",
                    LastName: "",
                    RelationshipId: relationshipId,
                    RecordStatus: 0,
                    tempIdCounter: raterId
                };
                this.raters.push(newRater);
                this.raters[this.raters.length - 1][e.target.name] = e.target.value;
                if (e.target.value != "") {
                    e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                } else {
                    let canDisable = true;
                    for (var i = 0; i < 3; i++) {
                        if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                            canDisable = false;
                        }
                    }
                    if (canDisable) {
                        this.raters.splice(this.raters.length - 1, 1);
                        //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    }
                }
            }
        }

        console.log('raters', this.raters);
        this.displayMinMessage(relationshipId);

    }

    sendEmail(e) {
        let raterId;
        console.log(raterId);

        //button clicked
        if (e.target.nodeName == 'A') {
            raterId = e.target.parentElement.parentElement.dataset.raterid;
        }
        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            raterId = e.target.parentElement.parentElement.parentElement.dataset.raterid
        }

        let regex = /tempId/;
        let result = regex.test(raterId);

        if (!result) {

            this._RatersService.postSendEmail(this.assignmentId, [raterId]).subscribe((data: any) => {
                console.log('response_sendEmail', data);
                $('body').css('cursor', 'default');
                if (this._Globals.validationToken(data.result.Result)) {
                    if (data.result.Result == 1) {
                        this._toastr.success("Email messages sent successfully", "ELI");
                    } else if (data.result.Result == 0) {
                        this._toastr.error("We are sorry. An error happened when trying to send the email messages.", "ELI");
                    }
                    setTimeout(() => {
                        $('#mainAccordion').trigger("click");
                    }, 100);
                }
            });
        }

    }

    showDeleteRatersConfirmationModal(e) {
        let showModal = false;
        let relationshipId;

        //button clicked
        if (e.target.nodeName == 'A') {
            relationshipId = parseInt(e.target.parentElement.parentElement.dataset.relationshipid);
            for (var i = 0; i < 3; i++) {
                if (e.target.parentNode.parentNode.children[i].children[0].value != "") {
                    showModal = true;
                }
            }
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            relationshipId = parseInt(e.target.parentElement.parentElement.parentElement.dataset.relationshipid);
            for (var i = 0; i < 3; i++) {
                if (e.target.parentNode.parentNode.parentNode.children[i].children[0].value != "") {
                    showModal = true;
                }
            }
        }

        //get the relationship min
        let relationship = this.raterTypes.filter((rt) => {
            if (relationshipId == rt.Id) return rt;
        });

        let inputEntries = $('.assignedAcc #acc' + relationshipId + ' .assignedCategoryEntries .row');
        if (showModal) {
            $("#assignedConfirmDeleteRatersModal").modal({ backdrop: "static" });
            $('#assignedConfirmDeleteRatersModal').modal('show');
        } else {
            if (inputEntries.length > relationship[0].Min) {
                this.deleteRaterEntry(e)
            } else {
                this._toastr.warning('You need a minimum of ' + relationship[0].Min + ' raters for this category', 'ELI');
                setTimeout(() => {
                    $('#relationships').trigger("click");
                }, 10);
            }
        }
    }

    hideDeleteRatersConfirmationModal() {
        $('#assignedConfirmDeleteRatersModal').modal('hide');
    }

    confirmDeleteRaters() {
        this.inProgress = true;
        this.deleteRaterEntry(this.ratertoDelete);
    }

    deleteRaterEntry(e: any) {
        console.log('click event', e);

        let raterId;

        //button clicked
        if (e.target.nodeName == 'A') {
            raterId = e.target.parentElement.parentElement.dataset.raterid;
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            raterId = e.target.parentElement.parentElement.parentElement.dataset.raterid
        }

        console.log('raterId', raterId);

        let regex = /tempId/;
        let result = regex.test(raterId);
        let relationshipId;

        //button clicked
        if (e.target.nodeName == 'A') {
            relationshipId = parseInt(e.target.parentElement.parentElement.dataset.relationshipid);
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            relationshipId = parseInt(e.target.parentElement.parentElement.parentElement.dataset.relationshipid);
        }
        console.log('relationshipId', relationshipId);

        if (!result) {
            //in database
            let raterPosition = this.raters.findIndex(x => x.RaterId === parseInt(raterId));
            if (raterPosition != -1) {
                this.raters[raterPosition].RecordStatus = 2;
                //relationshipId = this.raters[raterPosition].RelationshipId;
                this.deletedRaters.push(this.raters[raterPosition]);
                this.raters.splice(raterPosition, 1);
            }
        } else {
            //in memory
            let raterPosition = this.raters.findIndex(x => x.tempIdCounter === raterId);
            if (raterPosition != -1) {
                //relationshipId = this.raters[raterPosition].RelationshipId;
                this.raters.splice(raterPosition, 1);
            }
        }
        console.log('deleted', this.deletedRaters);
        //button clicked
        if (e.target.nodeName == 'A') {
            e.target.parentElement.parentElement.remove();
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            e.target.parentElement.parentElement.parentElement.remove();
        }

        //get the entries amount
        let entriesAmount = this.raters.filter((r) => {
            if (r.RelationshipId == relationshipId) return r;
        });
        //get the relationship min
        let relationship = this.raterTypes.filter((rt) => {
            if (relationshipId == rt.Id) return rt;
        });

        let inputEntries = $('.assignedAcc #acc' + relationshipId + ' .assignedCategoryEntries .row');
        if (entriesAmount.length < relationship[0].Min && inputEntries.length < relationship[0].Min) {
            this.addNewRaterEntry(relationshipId);
        }

        //display min message if category doesnt have enought raters
        this.displayMinMessage(relationshipId);

        this.hideDeleteRatersConfirmationModal();
        this.inProgress = false;
    }

    showBulkDeleteRatersConfirmationModal(rtId) {
        this.bulkDeleteCategoryId = rtId;

        let categoryRaters = this.raters.filter((r) => {
            if (rtId == r.RelationshipId) return r;
        });

        if (categoryRaters.length > 0) {
            $('.BDMessage').text('Are you sure to want to remove all the raters for this category (the category will be removed as well)?');
        } else {
            $('.BDMessage').text('Are you sure you want to remove this category from this assessment?');
        }

        $("#assignedBulkConfirmDeleteRatersModal").modal({ backdrop: "static" });
        $('#assignedBulkConfirmDeleteRatersModal').modal('show');
    }

    hideBulkDeleteRatersConfirmationModal() {
        $('#assignedBulkConfirmDeleteRatersModal').modal('hide');
    }

    confirmBulkDeleteRaters() {
        this.inProgress = true;
        this.removeCatergoryContent();
    }

    removeCatergoryContent() {
        console.log('removeCategoryContent');

        this.raters = this.raters.filter((r) => {
            if (this.bulkDeleteCategoryId !== r.RelationshipId) return r;
        });
        console.log(this.raters);

        $('.assignedAcc #acc' + this.bulkDeleteCategoryId).css('display', 'None');
        $('.assignedAcc #acc' + this.bulkDeleteCategoryId).removeClass('accOpen');
        $('.assignedAcc #acc' + this.bulkDeleteCategoryId).addClass('accHide');
        $('.assignedAcc div').removeClass('in');
        this.checkRatersAmount();
        this.hideBulkDeleteRatersConfirmationModal();
        this.inProgress = false;
    }

    saveRaters() {
        //validation 
        let requirements = true;
        let missingRatersCategories = [];
        let missingRatersCategoriesIds = [];

        let activeCategories = $('.accOpen');
        if (activeCategories.length == 0) {
            this._toastr.warning('You must enter raters for at least one category', 'ELI')
            return;
        }

        console.log(activeCategories);
        for (var i = 0; i < activeCategories.length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            r = r.replace(",", "");
            missingRatersCategoriesIds.push(parseInt(r));
        }

        missingRatersCategoriesIds.forEach((item) => {
            let relationshipIndex = this.raterTypes.findIndex(x => x.Id === item);
            if (relationshipIndex != -1) {

                let relationshipsEntries = this.raters.filter((r) => { if (r.RelationshipId === item) return r });

                if (relationshipsEntries.length < this.raterTypes[relationshipIndex].Min) {
                    requirements = false;
                    $('a#' + this.raterTypes[relationshipIndex].Id + '.ng-tns-c2-0').css('color', 'red');
                    missingRatersCategories.push(' ' + this.raterTypes[relationshipIndex].Name);
                } else {
                    $('a#' + this.raterTypes[relationshipIndex].Id + '.ng-tns-c2-0').css('color', '#63ceeb');
                }
            }
        });
        let unic = this.removeDuplicates(missingRatersCategories);

        if (!requirements) {
            this._toastr.warning(`You have not entered the minimum raters required for the following categories: ${unic.join()}`, 'ELI');
            return;
        }

        let raters = this.raters.filter((r) => {
            if ('RecordStatus' in r) return r;
        });
        console.log("raters", raters);

        let missingData = false;
        raters.forEach((item) => {
            if (item.Email === "" || item.FirstName === "" || item.LastName === "") {
                missingData = true;
            }
        });

        if (missingData) {
            this._toastr.warning('Please complete all the fields for the entered raters.', 'ELI');
            return;
        };

        $("#assignedSaveRatersModal").modal({ backdrop: "static" });
        $('#assignedSaveRatersModal').modal('show');
        console.log('saveRaters');
        this.addRaterNext();
        $("#assignedSaveRatersModal input[type=radio]").eq(0).prop("checked", true);
    }

    removeDuplicates(arr) {
        let s = new Set(arr);
        let it = s.values();
        return Array.from(it);
    }

    getRaterTypesForCoach(refreshData: boolean) {
        this._CoachService.getRaterTypesForCoach().subscribe((data: any) => {
            console.log('response_GetRaterTypesForCoach', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let oneopen = $('.fa-angle-up').length;
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetRaterTypesForCoach', _data);

                this.raterTypes = _data;
                this.rater.raterType = _data[0].Id;
                this.categoryMin = _data[0].Min;

                if (refreshData) {
                    let activeCategories = $('.accOpen');
                    console.log(activeCategories);
                    this.arrActiveCategories = [];
                    for (var i = 0; i < activeCategories.length; i++) {
                        let r = activeCategories[i].id.match(/\d/g).join(',');
                        r = r.replace(",", "");
                        this.arrActiveCategories.push(parseInt(r));
                    }

                    let selected = this.getSelectedRows(this.gridApi360);
                    //this.clientId = selected[0].ClientId;
                    //this.ratersHeaders = this.createRatersHeaders();
                    this.getRaters(selected[0].Id, false, oneopen);
                    //this.showRelationshipsModal();
                }
            }
        });
    }

    showConfirmCloseRatersModal() {
        let pristineCategories = [];
        let activeCategories = $('.accOpen');
        console.log(activeCategories);

        for (var i = 0; i < $('.accOpen').length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            r = r.replace(",", "");
            pristineCategories.push(parseInt(r));
        }

        if (!this.arraysAreEqual(this.raters, this.pristineRaters) || !this.arraysAreEqual(this.pristineCategories, pristineCategories)) {
            $("#assignedConfirmCloseRatersModal").modal({ backdrop: "static" });
            $('#assignedConfirmCloseRatersModal').modal('show');
        } else {
            this.closeModal();
        }
    }

    hideConfirmCloseRatersModal() {
        $('#assignedConfirmCloseRatersModal').modal('hide');
    }

    /*ratersModal*/
    showRatersModal() {
        let selected = this.getSelectedRows(this.gridApi360)
        this.ratersModal.show(selected[0].Id, selected[0].ClientId, 2, selected[0].ClientEmail);
    }

    goToConversionRate() {
        if (this._Globals.assignedCanConversionRate) {
            let selected = this.getSelectedRows(this.gridApi360)
            this.router.navigate(['/app/co_a_report', selected[0].Id, 'manage_assessments_assigned', 0]);
        }        
    }

    public getDisplayTagsCount(): number {
        const tags = $('[ng-reflect-input-id=tagsInput] > .ng2-tag-input > .ng2-tags-container > tag');

        return tags.length;
    }

    public getDisplay360TagsCount(): number {
        const tags = $('[ng-reflect-input-id=tagsInput360] > .ng2-tag-input > .ng2-tags-container > tag');

        return tags.length;
    }

    public reloadApplyingTagsFilter(): void {
        const tags = $('[ng-reflect-input-id=tagsInput] > .ng2-tag-input > .ng2-tags-container > tag')
        for(let count: number = 0; count< tags.length; count++){
            const tagText = tags[count].children[0].children[0].innerText.trim();
            this.tags.push(tagText);
            this.assessmentEliTags.push(tagText);
        }

        if (tags.length > 0) {
            this.getCoachAssignedAssessmentsByTypeByTag(1, this.assessmentEliTags);
        }
    }

    public reloadApplying360TagsFilter(): void {
        const tags360 = $('[ng-reflect-input-id=tagsInput360] > .ng2-tag-input > .ng2-tags-container > tag')
        for(let count: number = 0; count< tags360.length; count++){
            const tagText = tags360[count].children[0].children[0].innerText.trim();
            this.tags360.push(tagText);
            this.assessment360Tags.push(tagText);
        }

        if (tags360.length > 0) {
            this.getCoachAssignedAssessmentsByTypeByTag(2, this.assessment360Tags);
        }
    }
}